import ct from "class-types.macro";
import React from "react";

interface Props {
  alignTextClassName?: string;
}

export default function ContentLegalDisclaimer({
  alignTextClassName = "text-center",
}: Props) {
  return (
    <div
      className={`${ct(
        "clear-both",
        "text-2xs",
        "py-4",
        "text-gray-700",
        "w-full",
      )} ${alignTextClassName}`}
    >
      The information provided on this website does not, and is not intended to,
      constitute legal advice. Please refer to our{" "}
      <a href="/policies.html#Product_Policies">Content Policy</a> for more
      details.
    </div>
  );
}
